<template>
        <div :class="$style.container"
             v-loading.fullscreen.lock.body="loading"
             element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
        <div :class="$style.header">
            <!--<span :class="$style.remove" @click.stop="handleRemoveClick">移除</span>-->
            <span :class="$style.edit" @click.stop="handleEditClick" v-show="showEdit">编辑&nbsp;</span>
            <span :class="['iconfont', 'icon-touxiang', $style.avatar]"></span>
            <div :class="$style.userInfo">
                <span>{{info.last_name}}</span>
                <span v-if="info.manager==='T'">
                    <span v-if="info.users_status" :class="$style.manage">店长</span>
                </span>
                <!--<span v-if="info.users_status==='INACTIVE'">-->
                    <!--<span v-if="info.users_status" :class="$style.frozen">离职</span>-->
                <!--</span>-->
                <p style="font-size: 16px">{{getSex(info.gender)}} <i :class="['iconfont', 'icon-tel03', $style.tel]"></i>{{getPhone(info.mobile)}}
                </p>
            </div>
        </div>
        <!--<div :class="$style.body">-->
        <!--<p v-if="personnelName === 'first'">负责门店数量: <span :class="$style.date">{{info.stores.length}}家</span></p>-->
        <!--<p v-if="personnelName === 'second'">职务: <span :class="$style.date">{{info.title}}</span></p>-->
        <!--</div>-->
        <!-- 模态框 -->
        <el-dialog
                :visible.sync="showModal" :show-close="false"
                width="50%" :class="$style.modal" class="a_modal"
                :before-close="closeModal">
            <div slot="title" :class="$style.title">
                <span>店员详情</span>
                <div>
                    <el-button type="primary" size="small" @click.stop="handleSaveClick">保存</el-button>
                    <el-button type="danger" size="small" @click.stop="closeModal">取消</el-button>
                </div>
            </div>
            <el-form ref="ruleForm" :model="form" label-width="140px" class="info" style="margin-top: -20px">
                <el-form-item label="所属门店">
                    <span>{{getStoreName()}}</span>
                </el-form-item>

                <el-form-item label="姓名" prop="last_name">
                    <!--<span>{{form.userName}}</span>-->
                    <el-input v-model="form.last_name" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="gender">
                    <el-radio-group v-model="form.gender">
                        <el-radio label="M">男</el-radio>
                        <el-radio label="F">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="出生年月日">
                  <span>2016年7月</span>
                </el-form-item> -->
                <el-form-item label="手机号" prop="mobile">
                    <div v-if="addClerk">
                        <el-select v-model="code"
                                   placeholder="选择区号" style="width: 125px">
                            <el-option v-for="item in mobileArray" :key="item.code"
                                       :label="item.name"
                                       :value="item.code">
                                <span>{{item.name}}</span>
                            </el-option>
                        </el-select>
                        <el-input :class="$style.num" v-model="form.phone" type="number" @input="handleChange"></el-input>

                    </div>
                    <span v-else>{{getPhone(form.mobile)}}</span>

                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="form.email" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="店长">
                    <el-switch
                            v-model="isManager"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>

                <el-form-item label="在职">
                    <el-switch
                            v-model="isON"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>

                <el-form-item label="常用手机登录锁定">
                    <el-switch
                            v-model="deviceLock"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>

            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import http from '../../../APIService/http'
    import {bus} from '../../../router/index.js'

    export default {
        props: {
            info: {
                type: Object,
                default: () => {
                }
            },
            personnelName: {
                type: String,
                default: 'first'
            },
            options: {
                type: Array,
                default: () => []
            },
            store_id: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                loading: false,
                showModal: false,
                addClerk: false,
                showEdit:false,
                mobileArray:[{
                    code:'+86',
                    name:'+86 (中国)',
                    type:'F'
                },{
                    code:'00852',
                    name:'+852 (香港)',
                    type:'T'
                },{
                    code:'00853',
                    name:'+853 (澳门)',
                    type:'T'
                }],
                code:'+86',
                form: {
                    last_name:'',
                    gender:'',
                    mobile:'',
                    email:''
                },
                isManager: false,
                isON: false,
                deviceLock: false

            }
        },
        created() {

            let user = this.$store.getters.getUser

            if(!(user.isManage && !user.isSalesDirector) || user.role === 'admin'){
                this.showEdit = true
            }else {
                this.showEdit = false
            }

            bus.$off('action_addClerk');
            bus.$on('action_addClerk', (value) => {

                this.addClerk = true
                this.showModal = true


                if(this.$refs.ruleForm){
                    this.$refs.ruleForm.resetFields();
                }
                this.isON = true

            })

        },
        methods: {
            // 编辑按钮
            handleEditClick() {
                this.form = {...this.info}

                if (this.form.manager === 'T') {
                    this.isManager = true
                } else {
                    this.isManager = false
                }

                if (this.form.users_status === 'ACTIVE') {
                    this.isON = true // 是否在职
                } else {
                    this.isON = false
                }

                if (this.form.device_lock === 'T') {
                    this.deviceLock = true
                } else {
                    this.deviceLock = false
                }

                this.addClerk = false
                this.showModal = true
            },
            handleChange(value){
                let str= value.replace('.','')

                this.$nextTick(function () {
                    this.form.phone = str
                })
            },
            // 关闭模态框
            closeModal() {
                this.showModal = false
            },
            // 保存按钮
            handleSaveClick() {

                if(!this.form.last_name){
                    this.$message({
                        type: 'error',
                        message: '姓名不能为空'
                    })
                    return
                }

                if(this.form.email){
                    let regex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                    if(!regex.test(this.form.email)){
                        this.$message({
                            type: 'error',
                            message: '邮箱格式错误'
                        })
                        return
                    }
                }

                if(this.isManager){
                    this.form.manager = 'T'
                }else {
                    this.form.manager = 'F'
                }

                if(this.deviceLock){
                    this.form.device_lock = 'T'
                }else {
                    this.form.device_lock = 'F'
                }

                let statuStr = ''
                if(this.isON){//在职
                    statuStr = 'ACTIVE'
                }else {//离职
                    statuStr = 'INACTIVE'
                }

                this.loading = true

                if(this.addClerk){//新增

                    //检测手机号是否正确
                    if(this.code === '+86'){
                        let regex = /^[1][0123456789]\d{9}$/

                        if(!regex.test(this.form.phone)){
                            this.$message({
                                type: 'error',
                                message: '请输入正确的手机号'
                            })
                        }
                    }

                    this.addStoreClerk(statuStr)
                }else {
                    if(this.form.users_status === statuStr){//直接修改
                        this.update()
                    }else {//修改状态

                        this.setClerkStatus(statuStr)
                    }
                }




            },
            setClerkStatus(statuStr){
                if (statuStr === "ACTIVE") {//在职
                    this.getEnabledClerk();
                } else {//离职
                    this.getLeaveClerk();
                }
            },
            async getEnabledClerk() {
                try {

                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        store_id: this.store_id,
                        user_id: this.form.user_id
                    }

                    await http.post('/wapi/v1/enabled_Clerk', data).then(res => {

                        if (res.success) {
                            this.update()
                        } else {
                            this.loading = false
                            this.showModal = false
                            throw new Error('error')
                        }

                    })


                } catch (err) {
                    this.error('修改失败')
                }
            },async getLeaveClerk() {
                try {

                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        store_id: this.store_id,
                        user_id: this.form.user_id
                    }

                    await http.post('/wapi/v1/leave_Clerk', data).then(res => {

                        if (res.success) {
                            this.update()
                        } else {
                            this.loading = false
                            this.showModal = false
                            throw new Error('error')
                        }

                    })


                } catch (err) {
                    this.error('修改失败')
                }
            },
            getStoreName(){
                let obj = this.$store.getters.getStore
                return obj.name
            },
            // 保存按钮
            getPhone(phoneStr) {
                if (phoneStr.substring(0, 2) === "00") {
                    return "+" + phoneStr.substring(2, 5) + " " + phoneStr.substring(5);
                }
                return phoneStr;

            },
            getSex(sex) {
                if (sex === 'M') {
                    return '男'
                } else if (sex === 'F') {
                    return '女'
                } else {
                    return ''
                }
            },
            // 新增店员
            async addStoreClerk(statuStr) {
                try {

                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        device_lock: this.form.device_lock,
                        phone: this.code + this.form.phone,
                        gender: this.form.gender,
                        email: this.form.email,
                        alias: this.form.last_name,
                        status: statuStr,
                        store_name: this.getStoreName(),
                        store_id: this.store_id,
                        photo_id: '',
                        manager: this.form.manager,
                        from_user_id: user.user_id,
                        from_tenant_id: user.tenant_id,
                        from_alias: user.alias
                    }

                    await http.post('/wapi/v1/addStoreClerk', data).then(res => {

                        if (res.success) {
                            let t = this
                            setTimeout(function(){
                                t.$emit('increment', '')
                            },1000)


                            this.$message({
                                type: 'success',
                                message: '新增成功'
                            })
                            this.showModal = false
                            this.loading = false
                        } else {
                            // this.showModal = false
                            this.loading = false

                            this.error(res.message)
                        }

                    })


                } catch (err) {
                    this.error('修改失败')
                }
            },
            // 编辑店员
            async update() {
                try {


                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        device_lock: this.form.device_lock,
                        gender: this.form.gender,
                        email: this.form.email,
                        clerk_name: this.form.last_name,
                        manager: this.form.manager,
                        clerk_id: this.form.clerk_id,
                        people_id: this.form.people_id,
                        photo_id: this.form.photo_id,
                        user_id: this.form.user_id
                    }

                    await http.post('/wapi/v1/modifyStoreClerk', data).then(res => {

                        if (res.success) {
                            this.$emit('increment', '')
                            this.$message({
                                type: 'success',
                                message: '修改成功'
                            })
                            this.showModal = false
                            this.loading = false
                        } else {
                            this.showModal = false
                            this.loading = false
                            throw new Error('error')
                        }

                    })


                } catch (err) {
                    this.error('修改失败')
                }
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';

    .container {
        border: 1px solid #979797;
        width: 250px;

        margin-bottom: 20px;
        .num{
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none !important;
                margin: 0;
            }
            width: calc(100% - 132px)
        }
        .header {
            padding: 10px;
            &:after {
                display: block;
                content: '';
                overflow: hidden;
                clear: both;
            }
            .avatar {
                font-size: 40px;
                color: #FF9901;;
                float: left
            }
            .edit {
                color: #FF9901;
                font-size: 14px;
                float: right;
                cursor: pointer;
            }
            .remove {
                color: #FF0000;
                font-size: 14px;
                float: right;
                cursor: pointer;
            }
            .userInfo {
                span {
                    font-size: 14px;
                    font-weight: bold;
                    color: #2a363b;
                    vertical-align: middle;
                }
                .manage {
                    font-size: 12px;
                    color: #fff;
                    padding: 3px;
                    background: #FF9901;
                    border-radius: 3px;
                }
                .frozen {
                    font-size: 12px;
                    color: #fff;
                    padding: 3px;
                    background: #d1021b;
                    border-radius: 3px;
                }
                .tip {
                    font-size: 12px;
                    color: #fff;
                    padding: 3px;
                    background: #ff9801;
                    border-radius: 5px;
                }
                p {
                    margin: 10px 0px 0px;
                    color: #717d84;
                    opacity: 0.6;
                    .tel {
                        font-size: 16px;
                        margin-right: 8px;
                    }
                }
            }
        }
        .body {
            p {
                margin: 10px;
                color: #9da4ad;
                font-size: 16px;
                .date {
                    /*float: right;*/
                    color: #a2e065;
                    &:after {
                        display: inline-block;
                        content: '';
                        overflow: hidden;
                        clear: both;
                    }
                }
            }
        }
        .modal {
            .title {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: space-between;
                align-items: center;
                border-bottom: 2px dotted #e7eaec;
                padding-bottom: 10px;
                > span {
                    color: #3998f7;
                    font-size: 16px;
                }
            }
        }
    }
</style>

<style scoped>
    .a_modal >>> form {
        width: 90%;
        margin: 0 auto;
    }

    .a_modal >>> .el-form-item__label {
        color: #000000;
        font-size: 16px;
        text-align: right;
        font-weight: bold;
    }

    .a_modal >>> .el-select {
        width: 100%;
    }

    .a_modal >>> .el-form-item__content {
        color: #4a90e2;
        font-size: 16px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/pages/stores/clerk/clerkItem.vue